import { useNavigate } from 'react-router-dom';
import { Card, CardContent } from '../components/ui/card';
import { Button } from '../components/ui/button';
import { X } from 'lucide-react';

const BillingCancel = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-background flex items-center justify-center p-4" data-testid="billing-cancel">
      <Card className="card-farm max-w-md w-full">
        <CardContent className="py-12 text-center">
          <div className="w-16 h-16 mx-auto rounded-full bg-muted flex items-center justify-center mb-6">
            <X className="w-8 h-8 text-muted-foreground" />
          </div>
          <h1 className="font-heading text-2xl font-bold text-foreground mb-2">
            Payment Cancelled
          </h1>
          <p className="text-muted-foreground mb-6">
            No worries! You can subscribe anytime from the Settings page. 
            Your trial access continues.
          </p>
          <div className="flex gap-3 justify-center">
            <Button 
              variant="outline"
              onClick={() => navigate('/app/settings')}
            >
              Try Again
            </Button>
            <Button 
              onClick={() => navigate('/app')}
              className="btn-primary"
              data-testid="back-to-app-btn"
            >
              Back to Dashboard
            </Button>
          </div>
        </CardContent>
      </Card>
    </div>
  );
};

export default BillingCancel;
